import {
  QueryClient, QueryClientProvider
} from '@tanstack/react-query';
import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from 'react-hot-toast';

import App from "./App";
import AuthProvider from './context/AuthProvider';
import "./index.css";
import reportWebVitals from "./reportWebVitals";
const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient()
root.render(
  <React.StrictMode>
    <Toaster></Toaster>
    <QueryClientProvider client={queryClient}>     
    <AuthProvider>
      <App />     
    </AuthProvider>
    </QueryClientProvider>
 
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
